<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col>
        <SymposiaList :simposiums="simposiumsProccessed" />
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row class="pt-5" align="center" justify="center">
      <v-col>
        <PieChartCard
          v-if="simposiumsProccessed.length == symposiums.length"
          :simposiums="simposiumsProccessed"
        ></PieChartCard>
      </v-col>
      <v-col>
        <InscriptionsDataTable
          v-if="simposiumsProccessed.length"
          :simposiums="simposiumsProccessed"
        ></InscriptionsDataTable>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SymposiaList from "@/components/panel/SymposiaList";
import PieChartCard from "@/components/panel/charts/PieChartCard";
import { getSymposiums } from "@/services/symposiums.js";
import InscriptionsDataTable from "@/components/panel/InscriptionsDataTable";
import { getInscriptions } from "@/services/inscriptions.js";

export default {
  components: {
    SymposiaList,
    PieChartCard,
    InscriptionsDataTable
  },
  async mounted() {
    //console.log("mounted Panel");
    this.symposiums = await getSymposiums();
    //this.proccesSimposiums();
  },
  data() {
    return {
      symposiums: [],
      simposiumsProccessed: []
    };
  },
  watch: {
    symposiums() {
      this.proccesSimposiums();
    }
  },
  methods: {
    proccesSimposiums() {
      //console.log("proccesSimposiums");
      var context = this;
      context.simposiumsProccessed = [];
      //console.log("this.symposiums", this.symposiums);
      this.symposiums.forEach(async function(element) {
        var inscriptions = await getInscriptions(element.id);
        const pendingCount = inscriptions.filter(obj => obj.reviewed === false)
          .length;
        var simposio = {
          id: element.id,
          name: element.name,
          acronym: element.acronym,
          color: element.color,
          inscriptions: inscriptions,
          total: inscriptions.length,
          pendingReview: pendingCount,
          reviewed: inscriptions.length - pendingCount
        };
        context.simposiumsProccessed.push(simposio);
      });
    }
  }
};
</script>
